import { RESULTS_PER_PAGE, THIN_RESULTS_THRESHOLD } from '../constants';

const SEARCH_PARAMS_WHITELIST = [
  {
    name: 'locationSearchRadius',
    transform: (value) => (value ? parseInt(value, 10) : null),
  },
  { name: 'maxDate' },
  { name: 'minDate' },
  { name: 'popularityBoost' },
  { name: 'name' },
  { name: 'radius' },
  { name: 'sort' },
  { name: 'sport' },
  {
    name: 'sportDistance',
    transform: (value) => (value ? parseInt(value, 10) : null),
  },
  { name: 'tag' },
  { name: 'covid', transform: (value) => value === 'true' },
  {
    name: 'sportDistances',
    transform: (value) =>
      Array.isArray(value)
        ? value.map((n) => parseInt(n, 10))
        : [parseInt(value, 10)],
  },
  {
    name: 'tags',
    transform: (value) => (Array.isArray(value) ? value : [value]),
  },
  {
    name: 'dateRanges',
    transform: (value) => (Array.isArray(value) ? value : [value]),
  },
  { name: 'locationLong', transform: (value) => parseFloat(value) },
  { name: 'locationLat', transform: (value) => parseFloat(value) },
  { name: 'viewportNorthEastLat', transform: (value) => parseFloat(value) },
  { name: 'viewportNorthEastLong', transform: (value) => parseFloat(value) },
  { name: 'viewportSouthWestLat', transform: (value) => parseFloat(value) },
  { name: 'viewportSouthWestLong', transform: (value) => parseFloat(value) },
];
const SEARCH_PARAMS_WHITELIST_KEYS = Object.values(SEARCH_PARAMS_WHITELIST).map(
  (s) => s.name,
);
const DEFAULT_SEARCH_PARAMS = {
  viewportNorthEastLat: null,
  viewportNorthEastLong: null,
  viewportSouthWestLat: null,
  viewportSouthWestLong: null,
  locationLat: null,
  locationLong: null,
  locationSearchRadius: null,
  resultsPerPage: RESULTS_PER_PAGE,
  thinEventsThreshold: THIN_RESULTS_THRESHOLD,
};

const getPage = (query) => {
  try {
    const { page } = query;
    return +page || 1;
  } catch (exc) {
    return 1;
  }
};

export const getSearchParams = (query) => {
  const page = getPage(query);

  const params = Object.entries(query).reduce(
    (acc, [k, v]) => {
      const param = SEARCH_PARAMS_WHITELIST.find((n) => n.name === k);
      if (!param) return acc;
      const { transform } = param;
      acc[k] = transform ? transform(v) : v;
      return acc;
    },
    { ...DEFAULT_SEARCH_PARAMS, page },
  );

  if (
    params.viewportNorthEastLat === null &&
    params.viewportNorthEastLong === null &&
    params.viewportSouthWestLat === null &&
    params.viewportSouthWestLong === null &&
    params.locationLat === null &&
    params.locationLong === null &&
    params.locationSearchRadius === null
  ) {
    delete params.viewportNorthEastLat;
    delete params.viewportNorthEastLong;
    delete params.viewportSouthWestLat;
    delete params.viewportSouthWestLong;
    delete params.locationLat;
    delete params.locationLong;
    delete params.locationSearchRadius;
  }

  if (params.covid) {
    if (Array.isArray(params.tags)) {
      params.tags.push('covid-19');
    } else {
      params.tags = ['covid-19'];
    }
  }
  delete params.covid;

  return params;
};

// Having these in the url query does not constitute a custom filter.
const NON_CUSTOM_PARAMS = ['sort'];

// Returns true if any filters are present that are not explicitly marked
// as non custom.
export const queryHasCustomFilters = (query) =>
  Object.keys(query)
    // Key is a search filter.
    .filter((key) => SEARCH_PARAMS_WHITELIST_KEYS.includes(key))
    // Key is not an allowed, non-custom filter.
    .filter((key) => !NON_CUSTOM_PARAMS.includes(key)).length > 0;
